<!--
 * @Author: your name
 * @Date: 2021-07-09 14:29:09
 * @LastEditTime: 2022-08-19 11:49:32
 * @LastEditors: Please set LastEditors
 * @Description: 主视图
 * @FilePath: \smart-community\src\layout\module\LayoutMain.vue
-->
<template>
  <div
    class="LayoutMain"
    :style="{
      padding: routez === '/fileManagement' && '0',
      paddingTop: routez === '/fileManagement' && '5px',
    }"
    :class="{ space: true }"
  >
    <!-- v-if="isHome" -->
    <layout-breadcrumb v-if="isHome"></layout-breadcrumb>
    <div
      :style="{
        padding: routez === '/fileManagement' && '0',
        paddingTop: routez === '/fileManagement' && '5px',
      }"
      class="layout-main-page-box"
    >
      <router-view class="layout-main-page" :key="key" />
    </div>
  </div>
</template>
<script >
import { defineComponent, reactive, toRefs, watch } from "vue";
import LayoutBreadcrumb from "./LayoutBreadcrumb.vue";
import { useRoute, onBeforeRouteUpdate } from "vue-router";
export default defineComponent({
  name: "LayoutMain",
  components: { LayoutBreadcrumb },
  props: {},
  setup(props) {
    const route = useRoute();
    const data = reactive({
      routez: "",
      isHome: false,
    });
    const refData = toRefs(data);
    const key = () => {
      return route.path;
    };
    const isHomeFn = (to) => {
      if (to.name === "Home" || to.name === "threeSolidHome") {
        data.isHome = false;
      } else {
        data.isHome = true;
      }
    };
    isHomeFn(route);
    onBeforeRouteUpdate(async (to, from) => {
      isHomeFn(to);
    });
    watch(
      () => {
        data.routez = route.path;
        return data.routez;
      },
      (value) => {}
    );
    return { ...refData, key };
  },
});
</script>
<style lang='scss' scoped >
.LayoutMain {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1;
  &.space {
    // padding: 10px;
    padding-top: 5px;
    .layout-main-page-box {
      padding: 10px;
      padding-top: 5px;
    }
  }
  .layout-main-page-box {
    width: 100%;
    height: 100%;
    flex: 1;
    overflow: hidden;
  }
  .layout-main-page {
    width: 100%;
    height: 100%;
    flex: 1;
    overflow: hidden;
    background-color: var(--el-color-white);
    box-sizing: border-box;
  }
}
</style>
